export const validatorVisitorSearch = async (values) => {
    const isAnyValueDefined = values && Object.values(values).some(value => !!value);
    const errors = {
        isValuesUndefined: !isAnyValueDefined,
    };
    if (!errors.isValuesUndefined) {
        return;
    }
    return errors;
};
